<template>
  <div class="interrupted">
    <div class="content">
      <div>检查到本文章上次校对没有完成，是否继续上次校对？</div>
      <div>点击"是"继续上次校对</div>
      <div>点击"否"重新开始校对</div>
    </div>

    <div class="footer">
      <el-button type="primary" size="medium" plain @click="yes">是（Y)</el-button>
      <el-button type="primary" size="medium" plain @click="no">否（N)</el-button>
    </div>
  </div>
</template>

<script>
import Util from "@/components/js/util.js"
import dlgFunc from '../textProofreading/index.js';

export default {
  name: 'interrupted',
  methods: {
    yes() {
      dlgFunc.CWps.PluginStorage.setItem("isContinue", true);
      window.close();
      dlgFunc.openDialog('textProofreading', '', undefined, undefined, false);
      // dlgFunc.CWps.ShowDialog(
      //   Util.GetUrlPath() + "textProofreading",
      //   "通篇校对",
      //   150 * window.devicePixelRatio,
      //   150 * window.devicePixelRatio,
      //   true
      // );
    },
    no() {

    },
  }
}
</script>

<style scoped>
.interrupted {
  padding: 10px;
}

.footer {
  position: absolute;
  bottom: 20px;
  text-align: center;
  left: 0;
  right: 0;
}
</style>
